import * as i0 from "@angular/core";
import * as i1 from "../http-helpers/http.wrapper";
/**
 ****************************************************************
 * Proxy service class theme management.
 *
 * Created by Shai Zelman on 06/06/2020.
 ****************************************************************
 */
var ThemeProxy = /** @class */ (function () {
    function ThemeProxy(httpWrapper) {
        this.httpWrapper = httpWrapper;
    }
    ThemeProxy.prototype.getTheme = function () {
        return this.httpWrapper.getAnon("PatientPortalTheme", "GetTheme");
    };
    ThemeProxy.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ThemeProxy_Factory() { return new ThemeProxy(i0.ɵɵinject(i1.HttpWrapper)); }, token: ThemeProxy, providedIn: "root" });
    return ThemeProxy;
}());
export { ThemeProxy };
